import React, { Component } from 'react';
import { Button, Popover } from './';

export default class PopoverButton extends Component {
  state = {
    isOpen: false
  };

  toggle() {
    this.setState({ isOpen: !this.state.isOpen });
  }

  componentDidMount() {
    if (this.props.onLoad) this.props.onLoad(this);
  }

  render() {
    const { label, children, ...props } = this.props;
    const { isOpen } = this.state;

    return (
      <Popover isOpen={isOpen} onOuterAction={::this.toggle} body={children}>
        <Button onClick={::this.toggle} {...props}>{label}</Button>
      </Popover>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/common/popover-button.js